/* Mr Pixel — restricted-game age gate */

(function () {
  'use strict';

  var root = document.getElementById('mp-age-gate');
  var configEl = document.getElementById('mp-age-gate-config');
  if (!root || !configEl) return;

  var CFG;
  try {
    CFG = JSON.parse(configEl.textContent);
  } catch (error) {
    console.warn('[mp-age-gate] unreadable config, gate disabled', error);
    return;
  }

  var MAX_AGE = 18;
  var STORAGE_KEY = 'mp-age-confirmed';

  var TRIGGERS = [
    '[name="checkout"]',
    'a[href*="/checkout"]',
    '#wizz4-cart-link',
    '.wizz-checkout-link',
    '.wizz-checkout-button',
    '[data-mp-checkout]'
  ].join(',');

  var CHECKOUT_PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout(?:[/?#]|$)/i;

  var passThrough = false;
  var busy = false;
  var pendingTrigger = null;
  var pendingLines = [];
  var pendingAge = 0;
  var removalDone = false;
  var lastFocus = null;

  function confirmedAge() {
    try {
      return parseInt(window.sessionStorage.getItem(STORAGE_KEY), 10) || 0;
    } catch (error) {
      return 0;
    }
  }

  function rememberAge(age) {
    try {
      if (age > confirmedAge()) window.sessionStorage.setItem(STORAGE_KEY, String(age));
    } catch (error) {
    }
  }

  function fill(template, vars) {
    return String(template || '').replace(/\{(\w+)\}/g, function (whole, key) {
      return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : whole;
    });
  }

  function el(selector) {
    return root.querySelector(selector);
  }

  function totalUnits(lines) {
    return lines.reduce(function (sum, line) {
      return sum + (parseInt(line.quantity, 10) || 1);
    }, 0);
  }

  function isCheckoutLink(node) {
    if (node.tagName !== 'A') return true;
    var href = node.getAttribute('href') || '';
    if (!href) return false;
    try {
      return CHECKOUT_PATH.test(new URL(node.href, window.location.href).pathname);
    } catch (error) {
      return CHECKOUT_PATH.test(href);
    }
  }

  function triggerFor(event) {
    var node = event.target;
    if (node && node.nodeType !== 1) node = node.parentElement;

    var hit = node && node.closest ? node.closest(TRIGGERS) : null;

    if (!hit && event.type === 'submit') {
      var submitter = event.submitter;
      hit = submitter && submitter.closest ? submitter.closest(TRIGGERS) : null;
      if (!hit && event.target && event.target.querySelector) {
        hit = event.target.querySelector('[name="checkout"]');
      }
    }

    if (!hit || root.contains(hit)) return null;
    return isCheckoutLink(hit) ? hit : null;
  }

  function onCheckoutIntent(event) {
    if (passThrough) return;

    if (event.type === 'click') {
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    }

    var trigger = triggerFor(event);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    if (!root.hidden) {
      el('[data-mp-gate-panel]').focus();
      return;
    }
    if (busy) return;

    if (confirmedAge() >= MAX_AGE) {
      letThrough(trigger);
      return;
    }

    busy = true;

    fetch(CFG.feedUrl, {
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.lines)) {
          throw new Error('unexpected feed payload, not the age-gate template');
        }

        var lines = data.lines.filter(function (line) {
          return (parseInt(line.min_age, 10) || 0) > 0;
        });
        if (!lines.length) return letThrough(trigger);

        var needed = lines.reduce(function (highest, line) {
          return Math.max(highest, parseInt(line.min_age, 10) || 0);
        }, 0);
        if (needed <= confirmedAge()) return letThrough(trigger);

        busy = false;
        ask(trigger, lines, needed);
      })
      .catch(function (error) {
        console.warn('[mp-age-gate] classification lookup failed, letting checkout through', error);
        letThrough(trigger);
      });
  }

  function letThrough(trigger) {
    busy = false;
    passThrough = true;

    window.setTimeout(function () {
      try {
        if (trigger.tagName === 'A') {
          window.location.href = trigger.href;
        } else {
          trigger.click();
        }
      } finally {
        window.setTimeout(function () {
          passThrough = false;
        }, 0);
      }
    }, 0);
  }

  window.addEventListener('click', onCheckoutIntent, true);
  window.addEventListener('submit', onCheckoutIntent, true);

  function ask(trigger, lines, needed) {
    pendingTrigger = trigger;
    pendingLines = lines;
    pendingAge = needed;

    var highest = lines.slice().sort(function (a, b) {
      return (parseInt(b.min_age, 10) || 0) - (parseInt(a.min_age, 10) || 0);
    })[0];
    var units = totalUnits(lines);
    var vars = { rating: highest.rating, age: needed, count: units };

    el('[data-mp-gate-lead]').textContent = fill(units > 1 ? CFG.leadMany : CFG.leadOne, vars);
    el('[data-mp-gate-yes]').textContent = fill(CFG.yes, vars);

    var error = el('[data-mp-gate-error]');
    error.textContent = '';
    error.hidden = true;

    var list = el('[data-mp-gate-list]');
    list.textContent = '';
    lines.forEach(function (line) {
      var item = document.createElement('li');

      var title = document.createElement('span');
      title.className = 'mp-age-gate__item-title';
      var quantity = parseInt(line.quantity, 10) || 1;
      title.textContent = quantity > 1 ? line.title + ' \u00d7 ' + quantity : line.title;

      var tag = document.createElement('span');
      tag.className = 'mp-age-gate__tag';
      tag.textContent = line.rating;

      item.appendChild(title);
      item.appendChild(tag);
      list.appendChild(item);
    });

    show('ask');
  }

  function show(view) {
    if (root.hidden) lastFocus = document.activeElement;

    el('[data-mp-gate-view="ask"]').hidden = view !== 'ask';
    el('[data-mp-gate-view="removed"]').hidden = view !== 'removed';
    root.hidden = false;
    document.body.classList.add('mp-age-gate-open');

    document.addEventListener('keydown', onKeydown, true);
    el('[data-mp-gate-panel]').focus();
  }

  function close() {
    root.hidden = true;
    document.body.classList.remove('mp-age-gate-open');
    document.removeEventListener('keydown', onKeydown, true);
    pendingTrigger = null;
    pendingLines = [];

    if (removalDone) {
      window.location.reload();
      return;
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onYes() {
    var trigger = pendingTrigger;
    rememberAge(pendingAge);
    close();
    if (trigger) letThrough(trigger);
  }

  function onNo() {
    if (busy || !pendingLines.length) return;
    busy = true;

    var lines = pendingLines.slice();
    var removed = totalUnits(lines);
    var updates = {};
    lines.forEach(function (line) {
      updates[line.key] = 0;
    });

    fetch(CFG.cartUrl + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        busy = false;
        removalDone = true;
        pendingTrigger = null;
        pendingLines = [];

        var empty = !cart || cart.item_count === 0;
        var text = fill(removed > 1 ? CFG.removedMany : CFG.removedOne, { count: removed });
        text += ' ' + (empty ? CFG.removedEmpty : CFG.removedKept);

        el('[data-mp-gate-removed-lead]').textContent = text;
        el('[data-mp-gate-back]').hidden = empty;
        el('[data-mp-gate-browse]').hidden = !empty;
        show('removed');
      })
      .catch(function (error) {
        busy = false;
        console.warn('[mp-age-gate] could not remove the restricted lines', error);
        var box = el('[data-mp-gate-error]');
        box.textContent = CFG.error;
        box.hidden = false;
      });
  }

  function isVisible(node) {
    if (typeof node.checkVisibility === 'function') return node.checkVisibility();
    return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length);
  }

  function focusables() {
    var nodes = root.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, isVisible);
  }

  function onKeydown(event) {
    if (root.hidden) return;

    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      event.stopPropagation();
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (!root.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  root.addEventListener('click', function (event) {
    var node = event.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    if (!node || !node.closest) return;

    if (node.closest('[data-mp-gate-cancel]')) {
      event.preventDefault();
      close();
    } else if (node.closest('[data-mp-gate-yes]')) {
      event.preventDefault();
      onYes();
    } else if (node.closest('[data-mp-gate-no]')) {
      event.preventDefault();
      onNo();
    }
  });
})();
